<template>
    <div>
        <div class="row pl-3 pr-1 data-row mx-0">
            <div class="px-1 col-2">
                <basic-info></basic-info>
            </div>

            <div class="px-1 col-3">
                <div v-for="tgt in goal.parameters.targets" class="row no-gutters mb-1">
                    <span class="small mr-2 col-4">{{ tgt }}:</span>
                    <span class="small mr-2 col-4 text-right">{{
                        helpers._get(target, `data.results.${tgt}`, 0)
                    }}</span>
                    <span class="small mr-2 col-2 text-right">{{
                        target.data.time
                            ? Math.round(
                                  (100 * helpers._get(target, `data.results.${tgt}`, 0)) /
                                      (target.data.time / 60)
                              ) /
                                  100 +
                              "/min."
                            : "N/A"
                    }}</span>
                </div>
            </div>
            <div class="px-1 col-2">
                <small>{{ helpers.secondsToMinutes(target.data.time) }}</small>
            </div>
            <div class="px-1 col-1">
                <small>{{ target.progress }}%</small>
            </div>
            <div class="px-1 col-3">
                <small
                    ><span v-if="isBaseline" class="font-weight-bold text-uppercase text-primary"
                        >Baseline</span
                    >
                    {{ target.notes ? target.notes : "none" }}</small
                >
            </div>

            <div class="px-1 col-1">
                <data-actions
                    @delete-tracker="$emit('delete-tracker')"
                    @edit-target="$emit('edit-target', $event)"
                    @close-details="$emit('close-details')"
                ></data-actions>
            </div>
        </div>
    </div>
</template>

<script>
import BasicInfo from "./BasicInfo";
import DataActions from "./DataActions";

export default {
    name: "TrackerDataMultiTally",
    inject: ["goal", "target", "isBaseline"],
    components: {
        BasicInfo,
        DataActions,
    },
};
</script>
